import NsContent from 'components/common/ns-content/NsContent';
import NsIllustration from '@britishgasenergy/react-nucleus/dist/nuc-components/NsIllustration';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsPanel } from 'components/common/ns-panel/NsPanel';

export const BritishGasBenefits = () => {
  return (
    <NsPanel>
      <NsContent>
        <h2>Why choose British Gas?</h2>
      </NsContent>
      <NsColumn hockeypitch="3">
        <NsContent spacing="cosy">
          <NsIllustration name="payments" size="1"></NsIllustration>
          <h4>Half-price electricity every Sunday</h4>
          <p>
            Hundreds of thousands of customers are using their smart meters to
            save money with <b>PeakSave Sundays</b>. Join the fun and switch to
            British Gas.
          </p>
        </NsContent>
        <NsContent spacing="cosy">
          <NsIllustration name="circleTickBlue" size="1"></NsIllustration>
          <h4>Easy to switch</h4>
          <p>
            Select a tariff and we&apos;ll take care of the rest. Switching to
            us is easy, simple and hassle-free - backed by the Energy Switch
            Guarantee.
          </p>
        </NsContent>
        <NsContent spacing="cosy">
          <NsIllustration name="clock" size="1"></NsIllustration>
          <h4>You&apos;re in safe hands</h4>
          <p>
            We&apos;ve been around for 200 years and aren&apos;t going anywhere,
            powering over 8 million homes and businesses in Britain over the
            last year.
          </p>
        </NsContent>
      </NsColumn>
    </NsPanel>
  );
};
